import React from 'react';
import ReactDOM from 'react-dom';
import { browserHistory, Router, Route, IndexRoute, Link } from 'react-router';

import '../styles/chapter-inline-navi.scss';


class ChapterInlineNavi extends React.Component{

	constructor(props){
		super(props);
	}

	goToChapter(event){
		event.preventDefault();
		browserHistory.push('/chapter1');

	}

	render(){
		{/*/blossom*/}
		return ( 
			<div className={"main-intro-navi inline-"+this.props.inline}>											
				<nav className="main-front-nav">
					<Link to={"/"+ _assets.root + "/chapter1"} className="chapter-link chapter-active">{(this.props.list &&!_assets.isMobile) && <span>I - </span>}Doing Good</Link>
					<Link to={"/"+ _assets.root + "/chapter2"} className="chapter-link chapter-active">{(this.props.list &&!_assets.isMobile) && <span>II - </span>}Throwback</Link>
					<Link to={"/"+ _assets.root + "/chapter3"} className="chapter-link chapter-active">{(this.props.list &&!_assets.isMobile) && <span>III - </span>}Full Bloom</Link>
					{/*<span className="chapter-link inactive-link"><span className="chapter-name-link">{(this.props.list &&!_assets.isMobile) && <span>III - </span>}Full Bloom</span><span className="tool-tip-link">3rd March</span></span>*/}
				</nav>	
			</div>)
	}

}

export default ChapterInlineNavi;


// WEBPACK FOOTER //
// ./src/scripts/chapter_inline_navi.js